import { useAuth } from 'context/auth-context'
import { Navigate } from 'react-router-dom'

const ProtectedRoute = ({ children }) => {
    
    const token = localStorage.getItem("token");
    const { isAuthenticated } = useAuth()

    return isAuthenticated && token ? children : <Navigate to="/login" replace />
}

export default ProtectedRoute
